module.exports = __webpack_public_path__ + "static/media/sidebar_logo.a18b9efd.png";